import {Grid} from "@mui/material"
import React from "react"

const RaterModelos = () => {
    return (<Grid>
        </Grid>

    )
}

export default RaterModelos